module.exports = __webpack_public_path__ + "static/grid-30cc7a3bdc89ef4757f58c110b1463a1.mp4";